<div
  class="popup-modal"
  [@openDynamicComponent]="modalConfiguration.animation"
  [ngClass]="{ 'loader-overlay loading': isLoading | async }"
  (@openDynamicComponent.start)="onAnimationStart($event)"
  (@openDynamicComponent.done)="onAnimationDone($event)">
  <ng-template #container [cdkPortalOutlet]></ng-template>
</div>
